var React = require('react');

function VolumeCall (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.35938 13.4376V29.5626H14.1093L27.5469 43V0L14.1093 13.4376H3.35938Z","fill":"#8A9DA4","key":0}),React.createElement("path",{"d":"M32.9219 10.6829V32.3307C36.8993 30.3419 39.6406 26.2435 39.6406 21.5001C39.6406 16.7567 36.8995 12.6582 32.9219 10.6829Z","fill":"#8A9DA4","key":1})]);
}

VolumeCall.defaultProps = {"width":"43","height":"43","viewBox":"0 0 43 43","fill":"none"};

module.exports = VolumeCall;

VolumeCall.default = VolumeCall;
